<script lang="ts">
	import MixList from '../../Mix/MixList.svelte';

	export let row: any;
</script>

<MixList mixList={JSON.parse(row.combined)} />
